module.exports = __webpack_public_path__ + "static/img/company-5.166017ef.png";